/** Same platform-connected signal as Clients detail / readiness API (Task 3.2). */

export function readinessHasPlatform(readiness) {
  if (!readiness) return false;
  const social = readiness.items?.find((item) => item.key === 'social_accounts');
  if (social?.status === 'ok') return true;
  const platforms = readiness.platforms;
  if (platforms && typeof platforms === 'object') {
    return Object.values(platforms).some((row) => row?.connected);
  }
  return false;
}

/** GSC connected without last_error — enough for Rankings / SEO insight surfaces (16.R12). */
export function readinessHasGsc(readiness) {
  if (!readiness) return false;
  if (readiness.gsc?.connected && !readiness.gsc?.last_error) return true;
  const gscItem = readiness.items?.find((item) => item.key === 'gsc');
  return gscItem?.status === 'ok';
}

/** Social OAuth and/or GSC — for insight pages that must not require posts. */
export function readinessHasInsightConnection(readiness) {
  return readinessHasPlatform(readiness) || readinessHasGsc(readiness);
}

/** Client has scheduled or published posts (all-time, not just this week). */
export function readinessHasPosts(readiness) {
  if (readiness?.post_activity?.has_any) return true;
  // Backward compat if API predates post_activity.
  return (readiness?.cadence?.count ?? 0) > 0;
}

/**
 * @returns {'no_platform'|'no_posts'|null} null = show normal page content
 * Intended for read-only analytics pages — not Posts, Scheduling, or Gallery.
 *
 * Phase 16.R12: ``acceptGsc`` lets GSC-only / no-post clients into Rankings & SEO
 * without requiring social posts or social OAuth.
 */
export function resolveClientScopedVariant(
  readiness,
  { requirePosts = true, acceptGsc = false } = {},
) {
  if (!readiness) return null;
  const connected = acceptGsc
    ? readinessHasInsightConnection(readiness)
    : readinessHasPlatform(readiness);
  if (!connected) return 'no_platform';
  if (requirePosts && !readinessHasPosts(readiness)) return 'no_posts';
  return null;
}

export const CLIENT_SCOPED_VARIANTS = {
  NO_CLIENTS: 'no_clients',
  NO_PLATFORM: 'no_platform',
  NO_POSTS: 'no_posts',
};
